import { defineComponent as _defineComponent } from 'vue'
import { ref, provide } from 'vue';

import { ContextColorProvider } from '@warrenbrasil/nebraska-web';

import { PortabilityInformation } from './components/PortabilityInformation';
import { PortabilityRequestConclusion } from './components/PortabilityRequestConclusion';

import {
  PortabilityRequest,
  PortabilityRequestConclusionResponse
} from '@/modules/trade/services/portability';
import { PortabilityRequestSteps } from './types';


export default /*#__PURE__*/_defineComponent({
  __name: 'PortabilityRequestDetails',
  setup(__props) {

const step = ref<PortabilityRequestSteps>(PortabilityRequestSteps.Information);
const portabilityRequest = ref<PortabilityRequest | null>(null);
const portabilityRequestConclusion =
  ref<PortabilityRequestConclusionResponse | null>(null);

provide('portabilityRequest', portabilityRequest);
provide('portabilityRequestConclusion', portabilityRequestConclusion);

const handleChangeStep = (newStep: PortabilityRequestSteps) => {
  step.value = newStep;
};

return { __sfc: true,step, portabilityRequest, portabilityRequestConclusion, handleChangeStep, ContextColorProvider, PortabilityInformation, PortabilityRequestConclusion, PortabilityRequestSteps }
}

})